import { ESelectorState } from "./selectors";
/**
 * Whether a selector with this `when` condition is shown: the selector it names
 * is declared earlier and holds one of the listed values. A hidden selector
 * feeds nothing, as on the server.
 */
export function conditionHolds(condition, earlier) {
    if (!condition)
        return true;
    var state = earlier[condition.selector];
    return (state === null || state === void 0 ? void 0 : state.kind) === ESelectorState.VALUE && condition.in.includes(state.value);
}
